export default "__VITE_ASSET__CLbUxrkS__"